// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1K8EH","content":"styles_content__1qgcd","row":"styles_row__1-xoT","footer":"styles_footer__19n8_","phraseLength":"styles_phraseLength__XJfcF"};